import { render, staticRenderFns } from "./LmsFeedSlideShow.vue?vue&type=template&id=23077bd5&scoped=true"
import script from "./LmsFeedSlideShow.vue?vue&type=script&lang=js"
export * from "./LmsFeedSlideShow.vue?vue&type=script&lang=js"
import style0 from "./LmsFeedSlideShow.vue?vue&type=style&index=0&id=23077bd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23077bd5",
  null
  
)

export default component.exports